import { ExperienceVerificationStatusType } from '@apply/constants';
import { isMobileScreen } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faTriangleExclamation, faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';

export interface VerificationStatusIconCellProps {
    experienceStatusTypeId: ExperienceVerificationStatusType;
}

export const VerificationStatusIconCell: React.FC<VerificationStatusIconCellProps> = ({ experienceStatusTypeId }) => {
    const mobileScreen = isMobileScreen();
    const iconStyle = { width: 21, height: 21 };

    const iconMap: Record<
        ExperienceVerificationStatusType,
        { icon: any; color: string; flip?: boolean; rotate?: boolean; rotateDegrees?: number }
    > = {
        [ExperienceVerificationStatusType.Rejected]: {
            icon: faTriangleExclamation,
            color: '#EB5757',
        },
        [ExperienceVerificationStatusType.UnableToVerify]: {
            icon: faTriangleExclamation,
            color: '#EB5757',
        },
        [ExperienceVerificationStatusType.Submitted]: {
            icon: faClockRotateLeft,
            color: '#8E8E8E80',
            flip: true,
            rotate: true,
            rotateDegrees: 110,
        },
        [ExperienceVerificationStatusType.Verified]: {
            icon: faCircleCheck,
            color: '#219653',
        },
    };

    const config = iconMap[experienceStatusTypeId];

    const transforms: string[] = [];

    if (config?.flip) {
        transforms.push('scaleX(-1)');
    }

    if (config?.rotate) {
        transforms.push(`rotate(${config.rotateDegrees ?? 0}deg)`);
    }

    const transformValue = transforms.length > 0 ? transforms.join(' ') : undefined;

    return (
        <div style={{ display: 'flex', justifyContent: mobileScreen ? 'flex-end' : 'center' }}>
            {config && (
                <FontAwesomeIcon
                    icon={config.icon}
                    style={{
                        color: config.color,
                        ...iconStyle,
                        transform: transformValue,
                    }}
                />
            )}
        </div>
    );
};
